export default __webpack_public_path__ + "static/media/pof-bankStatementPOF.caeedcdc.png";